/**
 * Client-side filter: hides menu collection links with no available products.
 * Runs after page render so filtering is done before user hovers navigation.
 */
(function () {
  'use strict';

  const CACHE_KEY = 'menu_empty_collections';
  const CACHE_TTL_MS = 5 * 60 * 1000;
  const CONCURRENCY = 8;
  const MAX_BLOCK_MS = 1200; // Unblock menu after this even if filter still running

  function isDebugMode() {
    return document.querySelector('[data-empty-debug="true"]') !== null;
  }

  function getCache() {
    try {
      const raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return {};
      const parsed = JSON.parse(raw);
      if (Date.now() - parsed.ts > CACHE_TTL_MS) return {};
      return parsed.data || {};
    } catch {
      return {};
    }
  }

  function setCache(data) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ data: data, ts: Date.now() }));
    } catch (_) {}
  }

  function checkCollectionHasAvailable(handle) {
    return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=1&filter.v.availability=1')
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (json) {
        if (!json || !json.products) return false;
        return json.products.length > 0;
      })
      .catch(function () { return true; });
  }

  function hasChildMenuItems(el) {
    return el.querySelector('ul li') !== null;
  }

  function applyEmpty(el) {
    if (hasChildMenuItems(el)) return;
    if (isDebugMode()) {
      if (el.querySelector('[data-empty-marker]')) return;
      var link = el.tagName === 'A' ? el : el.querySelector('a');
      if (!link) link = el;
      var span = document.createElement('span');
      span.setAttribute('data-empty-marker', '');
      span.textContent = ' (empty)';
      span.style.color = 'red';
      link.appendChild(span);
    } else {
      el.style.display = 'none';
    }
  }

  function runFilter() {
    const containers = document.querySelectorAll('[data-hide-empty-collections="true"]');
    if (containers.length === 0) return Promise.resolve();

    const cache = getCache();
    const toFetch = [];
    const elementsByHandle = {};

    containers.forEach(function (container) {
      container.querySelectorAll('[data-collection-handle]').forEach(function (el) {
        const handle = el.getAttribute('data-collection-handle');
        if (!handle) return;
        if (cache[handle] !== undefined) {
          if (!cache[handle]) applyEmpty(el);
          return;
        }
        if (!elementsByHandle[handle]) {
          elementsByHandle[handle] = [];
          toFetch.push(handle);
        }
        elementsByHandle[handle].push(el);
      });
    });

    if (toFetch.length === 0) return Promise.resolve();

    var index = 0;
    function next() {
      if (index >= toFetch.length) return Promise.resolve();
      var handle = toFetch[index++];
      return checkCollectionHasAvailable(handle).then(function (hasAvailable) {
        cache[handle] = hasAvailable;
        return next();
      });
    }

    var workers = [];
    for (var i = 0; i < Math.min(CONCURRENCY, toFetch.length); i++) {
      workers.push(next());
    }
    return Promise.all(workers).then(function () {
      Object.keys(cache).forEach(function (handle) {
        if (!cache[handle]) {
          (elementsByHandle[handle] || []).forEach(function (el) {
            applyEmpty(el);
          });
        }
      });
      setCache(cache);
    });
  }

  function unlockMenu() {
    document.body.classList.remove('menu-filtering');
  }

  function init() {
    if (document.querySelectorAll('[data-hide-empty-collections="true"]').length === 0) return;
    setTimeout(unlockMenu, MAX_BLOCK_MS);
    runFilter().then(unlockMenu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
    window.addEventListener('load', init, { once: true });
  } else {
    init();
  }
  window.addEventListener('pagereveal', function (e) {
    if (e.viewTransition) init();
  });
  window.addEventListener('section-morphed', init);
})();
